export default __webpack_public_path__ + "79d17300d44955aeeef062e81d93b04a.svg";